"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Phone, MapPin } from "lucide-react";
import { Badge } from "@/components/ui/badge";
const contactCards = [{
  id: 1,
  label: "Call our team",
  value: "(470) 847-9076",
  subtext: "",
  type: "phone",
  href: "tel:+14708479076"
}, {
  id: 2,
  label: "Design studio",
  value: "Decatur, Georgia 30030",
  subtext: "Decatur, Georgia",
  type: "location",
  href: ""
}];
export default function Hero() {
  const prefersReducedMotion = useReducedMotion();
  const transitionConfig = prefersReducedMotion ? {
    duration: 0
  } : {
    duration: 0.4,
    ease: [0.16, 1, 0.3, 1]
  };
  const initialMotion = prefersReducedMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 16
  };
  return <section id="hero" data-nav="light" className="relative overflow-hidden bg-background text-foreground pt-28 pb-16 sm:pt-36 sm:pb-20 lg:pt-40 lg:pb-24 border-b border-border">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={initialMotion} animate={{
        opacity: 1,
        y: 0
      }} transition={transitionConfig} className="max-w-3xl">
          <Badge variant="outline" className="mb-4 rounded-full border-border bg-secondary text-foreground text-xs font-semibold uppercase tracking-wider px-3.5 py-1">
            Get in touch
          </Badge>

          <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground leading-[1.15]">
            Contact Decatur Heritage Renovations
          </h1>

          <div aria-hidden="true" className="mt-5 mb-6 h-[2px] w-20 bg-chart-1 rounded-full" />

          <p className="font-sans text-base sm:text-lg text-muted-foreground leading-relaxed max-w-2xl">
            Request a detailed estimate for your upcoming remodel, or discuss
            your home renovation plans directly with our local craft team.
          </p>
        </motion.div>

        <motion.div initial={initialMotion} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        ...transitionConfig,
        delay: prefersReducedMotion ? 0 : 0.12
      }} className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 max-w-2xl">
          {contactCards.map((item, i) => {
          const isPhone = item.type === "phone";
          const cardContent = <div data-index={i} className="h-full rounded-xl border border-border bg-card/85 p-6 backdrop-blur-md shadow-xs transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-1 hover:border-chart-1/40 hover:shadow-md flex flex-col justify-between">
                <div className="flex items-start gap-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary text-chart-1 border border-border">
                    {item.type === "phone" && <Phone className="size-5" aria-hidden="true" />}
                    {item.type === "location" && <MapPin className="size-5" aria-hidden="true" />}
                  </div>
                  <div>
                    <span className="font-sans text-xs font-medium uppercase tracking-wide text-muted-foreground block">
                      {item.label}
                    </span>
                    <p className="mt-1 font-sans text-base font-semibold text-card-foreground">
                      {item.value}
                    </p>
                    {item.subtext && <p className="mt-1 font-sans text-xs text-muted-foreground">
                        {item.subtext}
                      </p>}
                  </div>
                </div>
              </div>;
          return isPhone ? <a key={item.id} href="tel:+14708479076" className="block outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-xl">
                {cardContent}
              </a> : <div key={item.id}>{cardContent}</div>;
        })}
        </motion.div>
      </div>
    </section>;
}